module.exports = __webpack_public_path__ + "img/crust.9b29deb5.svg";